{
	"actions": {
		"cancel": "Cancel",
		"change_email": "Change email",
		"deactivate": "Deactivate",
		"open_menu": "User actions",
		"reactivate": "Reactivate",
		"remove": "Remove",
		"resend": "Resend invitation",
		"revoke": "Revoke invitation",
		"sending": "Sending…"
	},
	"change_email": {
		"description": "The invitation was sent to {{email}}.",
		"new_email": "New email",
		"sent": "Invitation sent to {{email}}.",
		"submit": "Change and send",
		"supersedes": "The link sent to the previous address stops working immediately, and a new invitation is sent to this address.",
		"title": "Change invitation email"
	},
	"columns": {
		"actions": "Actions",
		"email": "Email",
		"invitation": "Invitation",
		"last_activity": "Last activity",
		"name": "Name",
		"status": "Status"
	},
	"deactivate": {
		"confirm": "Deactivate",
		"description": "Their open sessions are closed and their access to the console stays blocked until you reactivate them.",
		"done": "{{name}} deactivated.",
		"pending": "Deactivating…",
		"title": "Deactivate {{name}}?"
	},
	"empty": {
		"description": "Nobody can sign in to this console yet. Invite a user to get started.",
		"no_matches_description": "No user matches the search or the active filters.",
		"no_matches_title": "No results",
		"title": "No users"
	},
	"filters": {
		"status": "Status"
	},
	"invitation": {
		"expired": "Expired on {{date}}",
		"expires": "Expires on {{date}}",
		"sent": "Sent on {{date}}"
	},
	"invite": {
		"action": "Invite user",
		"description": "They will receive an email with a link to choose a password and activate their access to the console.",
		"email": "Email",
		"email_invalid": "Enter a valid email address.",
		"email_placeholder": "name@company.com",
		"email_required": "Enter an email address.",
		"language": "Email language",
		"sent": "Invitation sent to {{email}}.",
		"submit": "Send invitation",
		"title": "Invite a user"
	},
	"never": "Never",
	"no_value": "Not available",
	"page_title": "Users",
	"reactivate": {
		"confirm": "Reactivate",
		"description": "Their access to the console is restored. They will need to sign in again: sessions closed by the deactivation are not restored.",
		"done": "{{name}} reactivated.",
		"pending": "Reactivating…",
		"title": "Reactivate {{name}}?"
	},
	"refusals": {
		"already_exists": "This address already belongs to a user or has a pending invitation.",
		"last_active_operator": "This is the last active user: without this account nobody could sign in to the console. Invite or reactivate another user first.",
		"self_action": "You cannot do this to your own account. Ask another user to do it for you."
	},
	"remove": {
		"confirm": "Remove",
		"description": "They lose access to the console for good. Their actions stay in the audit log. This cannot be undone.",
		"done": "{{name}} removed.",
		"pending": "Removing…",
		"title": "Remove {{name}}?"
	},
	"resend": {
		"confirm": "Resend",
		"description": "A new link is sent to the same address. The previous link stops working immediately.",
		"done": "Invitation sent again to {{name}}.",
		"pending": "Sending…",
		"title": "Resend the invitation to {{name}}?"
	},
	"revoke": {
		"confirm": "Revoke",
		"description": "The link in the email stops working and the invitation is removed from the list. You can invite the same address again later.",
		"done": "Invitation to {{name}} revoked.",
		"pending": "Revoking…",
		"title": "Revoke the invitation to {{name}}?"
	},
	"search_placeholder": "Search by name or email",
	"status": {
		"active": "Active",
		"disabled": "Deactivated",
		"expired": "Invitation expired",
		"invited": "Invited"
	},
	"total_one": "{{count}} user",
	"total_other": "{{count}} users",
	"you": "You"
}
